"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabPane = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var partition_1 = tslib_1.__importDefault(require("lodash/partition"));
var hook_1 = require("./hook");
var utils_1 = require("../utils");
var ConfigProvider_1 = require("../ConfigProvider");
var TabNavUnderscore_1 = tslib_1.__importDefault(require("./TabNavUnderscore"));
var TabPane_1 = tslib_1.__importDefault(require("./TabPane"));
var hooks_1 = require("../utils/hooks");
var TabNav_1 = require("./TabNav");
var TabPane_2 = require("./TabPane");
Object.defineProperty(exports, "TabPane", { enumerable: true, get: function () { return tslib_1.__importDefault(TabPane_2).default; } });
tslib_1.__exportStar(require("./TabNav"), exports);
tslib_1.__exportStar(require("./types"), exports);
function Tabs(props) {
    var children = props.children, className = props.className, defaultValue = props.defaultValue, _a = props.type, type = _a === void 0 ? 'horizontal' : _a, propValue = props.value, _b = props.size, size = _b === void 0 ? 'default' : _b, style = props.style, onChange = props.onChange, rootHtmlProps = props.rootHtmlProps, extra = props.extra;
    var prefix = ConfigProvider_1.usePrefix('tabs');
    var sizePrefix = utils_1.concat(prefix, size);
    var typePrefix = utils_1.concat(prefix, type);
    var navPrefix = utils_1.concat(prefix, 'nav');
    var _c = react_1.useState(getTabsFromChildren(children)), tabs = _c[0], setTabs = _c[1];
    var _d = react_1.useState(null), activeTabNavDom = _d[0], setActiveTabNavDom = _d[1];
    var _e = hooks_1.useValue({
        valueFromProps: propValue,
        defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : tabs[0].value, onChange: onChange
    }), activeValue = _e.value, setActiveValue = _e.setValue;
    var classname = classnames_1.default(prefix, className, sizePrefix, typePrefix, rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.className);
    var tabNavItems = tabs.map(function (_a) {
        var name = _a.name, value = _a.value;
        return (react_1.default.createElement("li", { key: value, ref: function (dom) { return value === activeValue && setActiveTabNavDom(dom); }, className: classnames_1.default(utils_1.concat(navPrefix, 'item'), value === activeValue && utils_1.concat(navPrefix, 'item', 'active')), onClick: function () { return setActiveValue(value); } }, name));
    });
    var contextValue = react_1.useMemo(function () { return ({
        prefix: prefix,
        size: size,
        type: type,
        tabs: tabs,
        value: activeValue
    }); }, [prefix, size, type, tabs, activeValue]);
    react_1.useEffect(function () {
        setTabs(getTabsFromChildren(children));
    }, [children]);
    // 如果没有 value 和 defaultValue，找出第一个面板的 value 作为内部 value
    react_1.useEffect(function () {
        if (activeValue == null && tabs.length > 0) {
            setActiveValue(tabs[0].value);
        }
    }, [activeValue, setActiveValue, tabs]);
    // 检查是否有 TabPane，如果有，则 nav 会有下边框
    var hasTabPane = react_1.useMemo(function () { return react_1.default.Children.toArray(children)
        .filter(react_1.isValidElement)
        .some(function (child) { return child.type === TabPane_1.default; }); }, [children]);
    return (react_1.default.createElement(hook_1.tabsContext.Provider, { value: contextValue },
        react_1.default.createElement("div", tslib_1.__assign({}, rootHtmlProps, { className: classname, style: tslib_1.__assign(tslib_1.__assign({}, style), rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.style) }),
            react_1.default.createElement("ul", { className: navPrefix },
                tabNavItems,
                react_1.default.createElement(TabNavUnderscore_1.default, { prefix: navPrefix, tabNavDom: activeTabNavDom }),
                extra && react_1.default.createElement("li", { className: utils_1.concat(navPrefix, 'extra') }, extra),
                (type === 'horizontal' || type === 'vertical') && hasTabPane && react_1.default.createElement("li", { className: utils_1.concat(navPrefix, 'border') })),
            react_1.default.Children.map(children, function (child) {
                if (!react_1.isValidElement(child)) {
                    return null;
                }
                return react_1.cloneElement(child);
            }))));
}
exports.default = Tabs;
function getTabsFromChildren(children) {
    var arr = react_1.default.Children.toArray(children).filter(isValidChild);
    var _a = partition_1.default(arr, isTabPane), tabPanes = _a[0], tabNavs = _a[1];
    if (tabPanes.length > 0 && tabNavs.length > 0) {
        throw Error('Unexpected mix of `TabPane` and `TabNav`');
    }
    if (tabPanes.length > 0) {
        return tabPanes.map(function (tabPane) { return ({ name: tabPane.props.name, value: tabPane.props.value }); });
    }
    return tabNavs.map(function (tabNav) { return ({ name: tabNav.props.children, value: tabNav.props.value }); });
}
function isTabNav(child) {
    return child.type === TabNav_1.TabNav;
}
function isTabPane(child) {
    return child.type === TabPane_1.default;
}
function isValidChild(child) {
    if (!react_1.isValidElement(child)) {
        return false;
    }
    if (isTabNav(child)) {
        return true;
    }
    if (isTabPane(child)) {
        return true;
    }
    throw TypeError('Unsupported Element Type, component as Tabs\'s children should be TabPane or TabNav.');
}
//# sourceMappingURL=index.js.map